import { UseFormReturn } from 'react-hook-form';

import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

import { AuthLegalNotice } from '@/components/AuthLegalNotice';
import { PartnerPasswordRules } from './PartnerPasswordRules';
import { PartnerSignupLoginLink } from './PartnerSignupLoginLink';
import { PARTNER_PASSWORD_RULES } from '../utils/constants';
import { PartnerSignupFormData } from '../utils/schema';

interface PartnerSignupFormProps {
  form: UseFormReturn<PartnerSignupFormData>;
  password: string;
  isSubmitting: boolean;
  emailFromUrl: string | null;
  onSubmit: (data: PartnerSignupFormData) => void;
}

export function PartnerSignupForm({
  form,
  password,
  isSubmitting,
  emailFromUrl,
  onSubmit,
}: PartnerSignupFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div>
          <label htmlFor="partner-email" className="block text-sm font-medium text-gray-700 mb-1">
            E-mail
          </label>
          <Input
            id="partner-email"
            type="email"
            {...register('email')}
            className="w-full"
            placeholder="user@email.com"
            error={errors.email?.message}
            disabled={!!emailFromUrl}
          />
        </div>
        <div>
          <label htmlFor="partner-password" className="block text-sm font-medium text-gray-700 mb-1">
            Senha
          </label>
          <Input
            id="partner-password"
            type="password"
            {...register('password')}
            placeholder="Digite sua senha"
            error={errors.password?.message}
          />
          <PartnerPasswordRules password={password} rules={PARTNER_PASSWORD_RULES} />
        </div>
        <div>
          <label htmlFor="partner-confirm-password" className="block text-sm font-medium text-gray-700 mb-1">
            Confirme sua Senha
          </label>
          <Input
            id="partner-confirm-password"
            type="password"
            {...register('confirmPassword')}
            placeholder="Digite sua senha"
            error={errors.confirmPassword?.message}
          />
        </div>
        <AuthLegalNotice />
        <Button
          type="submit"
          disabled={!isValid || isSubmitting}
          className="w-full bg-black text-white hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Ativando conta...' : 'Continuar'}
        </Button>
      </form>
      <PartnerSignupLoginLink />
    </>
  );
}
